import React                      from 'react';
import { goldFingers as tooltip } from 'pu-data/Tooltips';
import TextComponent              from './TextComponent';

const GoldFingers = (props) => {
  const name = 'gold_fingers';
  const onChange = e => props.onChangeParameter(name, e.target.value);
  return (
    <TextComponent
      label={props.label}
      name={name}
      value={props.parameters[name] || ''}
      required={props.required}
      onChange={onChange}
      tooltip={props.tooltip}
      groupName={props.groupName} />
  );
};

GoldFingers.defaultProps = {
  label: '# of Fingers<br class="d-none d-lg-block" /> (one side)',
  tooltip,
};

export default GoldFingers;
